
import axios from '@/axios.js'

export default {
  // TASK
    fetchTranksaksi ({ commit }, payload) {
      return new Promise((resolve, reject) => {
        axios.post('/tranksaksi-list', payload)
          .then((response) => {
            commit('SET_TASKS', response.data.data.tranksaksi)
            commit('SET_TOTALS', response.data.data.total)
            commit('SET_LAST', response.data.data.last_page)
            commit('SET_PER_PAGE', response.data.data.per_page)
            commit('SET_CURRENT_PAGE', response.data.data.current_page)
            commit('SET_MAX_RANGE', response.data.data.range_max)
            commit('SET_KATEGORIS', response.data.data.kategori)
            resolve(response)
          })
          .catch((error) => { reject(error) })
      })
    },

    addUpdate ({ commit }, data) {
      return new Promise((resolve, reject) => {
        axios.post('/tranksaksi-add', data)
        .then((response) => {
          commit('ADD_UPDATE', response.data.data)
          resolve(response.data)
        })
        .catch((error) => { reject(error) })
      })
    },

    editUpdate ({ commit }, data) {
      return new Promise((resolve, reject) => {
        axios.post('/tranksaksi-add', data)
        .then((response) => {
          commit('EDIT_UPDATE', response.data.data)
          resolve(response.data)
        })
        .catch((error) => { reject(error) })
      })
    },

    removeTranksaksi ({ commit }, data) {
      return new Promise((resolve, reject) => {
        axios.post('/tranksaksi-remove', data)
        .then((response) => {
          commit('REMOVE_TRANKSAKSI', data.id)
          resolve(response.data)
        })
        .catch((error) => { reject(error) })
      })
    },

    restoreTranksaksi ({ commit }, data) {
      return new Promise((resolve, reject) => {
        axios.post('/tranksaksi-restore', data)
        .then((response) => {
          commit('REMOVE_TRANKSAKSI', data.id)
          resolve(response.data)
        })
        .catch((error) => { reject(error) })
      })
    },
  
  // TIPE
    addKategori ({ commit }, tipe) {
      return new Promise((resolve, reject) => {
        axios.post('/term-add', tipe)
          .then((response) => {
            commit('ADD_KATEGORI', response.data.data)
            resolve(response.data)
          })
          .catch((error) => { reject(error) })
      })
    },

  // TAG
    fetchTag ({ commit }, tag) {
      return new Promise((resolve, reject) => {
        axios.get(`/term-list/tag-${tag}`)
          .then((response) => {
            commit('SET_TAGS', response.data.data)
            resolve(response.data)
          })
          .catch((error) => { reject(error) })
      })
    },
    addTag ({ commit }, tag) {
      return new Promise((resolve, reject) => {
        axios.post('/term-add', tag)
          .then((response) => {
            commit('ADD_TAG', response.data.data)
            resolve(response.data)
          })
          .catch((error) => { reject(error) })
      })
    },
    setTag ({ commit }, payload) {
      return new Promise((resolve, reject) => {
        axios.post('/set-tags', payload)
        .then((response) => {
          commit('UPDATE_TAGS', payload)
          resolve(response)
        })
        .catch((error) => { reject(error) })
      })
    },

  // PEMBAYARAN
    fetchPembayaran ({ commit }, data) {
      return new Promise((resolve, reject) => {
        axios.get(`/pembayaran-list/${data.id}/${data.total}`)
        .then((response) => {
          commit('SET_PEMBAYARAN', response.data.data.pembayaran_list)
          commit('SET_PEMBAYARAN_TOTAL', response.data.data.pembayaran_total)
          commit('SET_PEMBAYARAN_SISA', response.data.data.pembayaran_sisa)
          commit('SET_PEMBAYARAN_STATUS', response.data.data.pembayaran_status)
          resolve(response)
        })
        .catch((error) => { reject(error) })
      })
    },

    addPembayaran ({ commit }, data) {
      return new Promise((resolve, reject) => {
        axios.post('/pembayaran-add', data)
        .then((response) => {
          commit('ADD_UPDATE_PEMBAYARAN', response.data.data)
          resolve(response.data)
        })
        .catch((error) => { reject(error) })
      })
    },

    editPembayaran ({ commit }, data) {
      return new Promise((resolve, reject) => {
        axios.post('/pembayaran-add', data)
        .then((response) => {
          commit('EDIT_UPDATE_PEMBAYARAN', response.data.data)
          resolve(response.data)
        })
        .catch((error) => { reject(error) })
      })
    },

    removePembayaran ({ commit }, payload) {
      return new Promise((resolve, reject) => {
        axios.post('/pembayaran-remove', payload)
        .then((response) => {
          commit('REMOVE_PEMBAYARAN', response.data.data)
          resolve(response.data)
        })
        .catch((error) => { reject(error) })
      })
    },

    fetchPembayaranTrash ({ commit }, data) {
      return new Promise((resolve, reject) => {
        axios.get(`/pembayaran-trash/${data.id}/${data.total}`)
        .then((response) => {
          commit('SET_PEMBAYARAN', response.data.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
      })
    },

    restorePembayaran ({ commit }, data) {
      return new Promise((resolve, reject) => {
        axios.post('/pembayaran-restore', data)
        .then((response) => {
          commit('RESTORE_PEMBAYARAN', response.data.data)
          resolve(response.data)
        })
        .catch((error) => { reject(error) })
      })
    },

}
